interface EnumType {
  [id: number]: string;
}

export const getEnumKeyByStringValue = (enumInput: EnumType, value: string) =>
  Object.keys(enumInput)[Object.values(enumInput).indexOf(value)];
